import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { toast } from "sonner";

/** Loads the credit balance + recent transactions and keeps auto-refill form state in sync. */
export const useCreditsData = () => {
  const [balance, setBalance] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [arEnabled, setArEnabled] = useState(false);
  const [arThreshold, setArThreshold] = useState("0.50");
  const [arAmount, setArAmount] = useState("10.00");

  const loadBalance = useCallback(async () => {
    try {
      const { data } = await api.get("/credits/balance");
      setBalance(data);
      setArEnabled(data.auto_refill_enabled);
      setArThreshold(Number(data.auto_refill_threshold).toFixed(2));
      setArAmount(Number(data.auto_refill_amount).toFixed(2));
    } catch {
      toast.error("Could not load credit balance");
    }
  }, []);

  const loadTransactions = useCallback(async () => {
    try {
      const { data } = await api.get("/credits/transactions");
      setTransactions(data);
    } catch (err) {
      logError("Failed to load transactions", err);
    }
  }, []);

  useEffect(() => { loadBalance(); loadTransactions(); }, [loadBalance, loadTransactions]);

  return {
    balance, transactions, loadBalance, loadTransactions,
    arEnabled, setArEnabled, arThreshold, setArThreshold, arAmount, setArAmount,
  };
};
